import template from './doorWindowInstallationModal.html';

class WindowInstallationModalComponent {
    /*@ngInject*/
    constructor(actionContext, $ngRedux) {
        this.actionContext = actionContext;
        this.$ngRedux = $ngRedux;
        this.installationImages = [];
        this.productSku = '';

        this.images = {
            new: {
                doorInstallationCorrect: '/Content/images/photos/2018_Door_Correct-Edited_FINAL.jpg',
                doorInstallationIncorrect: '/Content/images/photos/2018_Door_Incorrect-Edited_FINAL.jpg',
                windowInstallationCorrect: '/Content/images/photos/2018_Window_Correct-Edited_FINAL.jpg',
                windowInstallationIncorrect: '/Content/images/photos/2018_Window_Incorrect-Edited_FINAL.jpg'
            },
            old: {
                doorInstallationCorrect: '/Content/images/photos/doorInstallation_Correct.png',
                doorInstallationIncorrect: '/Content/images/photos/doorInstallation_Incorrect.png',
                windowInstallationCorrect: '/Content/images/photos/windowInstallation_Correct.png',
                windowInstallationIncorrect: '/Content/images/photos/windowInstallation_Incorrect.png'
            }
        };
    }

    $onInit() {
        this.installationImages = this.sku === 'DWS'
            ? this.images.old
            : this.images.new;
    }
}

export default {
    template: template,
    bindings: {
        sku: '@'
    },
    controller: WindowInstallationModalComponent
};